export default "__VITE_ASSET__D2ZAcnYW__"